import { RefObject, useCallback } from 'react';

export const useScrollToTabsIfNeeded = (refElement: RefObject<HTMLDivElement | null>) => {
  const scrollToTabsIfNeeded = useCallback(() => {
    if (!refElement?.current) {
      return;
    }

    if (refElement.current.getBoundingClientRect().top > 0) {
      return;
    }

    refElement.current.scrollIntoView({ behavior: 'smooth' });
  }, []);

  return scrollToTabsIfNeeded;
};
